module.exports = __webpack_public_path__ + "static/media/JM_iconos-04_aula.e4681d10.svg";